// //=require ../../libraries/bootstrap-3.3.7/js/jquery-3.1.1.js
// //=require ../../libraries/bootstrap-3.3.7/js/affix.js
// //=require ../../libraries/bootstrap-3.3.7/js/alert.js
// //=require ../../libraries/bootstrap-3.3.7/js/button.js
// //=require ../../libraries/bootstrap-3.3.7/js/carousel.js
// //=require ../../libraries/bootstrap-3.3.7/js/collapse.js
// //=require ../../libraries/bootstrap-3.3.7/js/dropdown.js
// //=require ../../libraries/bootstrap-3.3.7/js/tooltip.js
// //=require ../../libraries/bootstrap-3.3.7/js/modal.js
// //=require ../../libraries/bootstrap-3.3.7/js/popover.js
// //=require ../../libraries/bootstrap-3.3.7/js/scrollspy.js
// //=require ../../libraries/bootstrap-3.3.7/js/tab.js
// //=require ../../libraries/bootstrap-3.3.7/js/transition.js